import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { CircleX } from 'lucide-react';
import type React from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import BaseLayout from '@/layouts/base';

interface ErrorPageProps extends React.PropsWithChildren {
  onRetry?: () => void;
}

const ErrorPage = ({ children, onRetry }: ErrorPageProps) => {
  const { t } = useTranslation();

  return (
    <BaseLayout className="-md:justify-center space-y-8" size="sm">
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <CircleX />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>{t('errorPage.default.title')}</PageHeadingTitle>
        <PageHeadingDescription>{children ?? t('errorPage.default.description')}</PageHeadingDescription>
      </PageHeading>
      <footer className="flex flex-col gap-4">
        {onRetry ? (
          <Button size="lg" variant="primary" onClick={onRetry}>
            {t('buttons.retry')}
          </Button>
        ) : null}
        <Button size="lg" variant={onRetry ? 'outline' : 'primary'} asChild>
          <a href={import.meta.env.VITE_APP_SUPPORT_NEW_REQUEST_URL}>{t('contactSupport')}</a>
        </Button>
      </footer>
    </BaseLayout>
  );
};
ErrorPage.displayName = 'ErrorPage';

export default ErrorPage;
